import React, {Component} from 'react';
import './SubNav2.css';
// import {NavLink} from 'react-router-dom';
// import AnchorLink from 'react-anchor-link-smooth-scroll';
import '../../assets/css/Icons.css';

export default class SubNav2 extends Component{
    render(){
        return(
            <div className="SubNavDiv2">
            </div>
        );
    }
}